interface EmailTemplateProps {
  appUrl: string
  content: string
}

export function emailTemplate(props: EmailTemplateProps) {
  const unsubscribeUrl = `${props.appUrl || 'https://platform.cobrief.app'}/email-unsubscribe`

  return `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="utf-8">
        <meta http-equiv="x-ua-compatible" content="ie=edge">
        <title>Email from Cobrief</title>
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <meta name="x-apple-disable-message-reformatting" />
        <style type="text/css">
          html, body {
            margin: 0;
            padding: 0;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
          }
          body {
            font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif;
            line-height: 1.6;
            font-size: 16px;
            color: #000000;
            background-color: #f6f9fc;
            padding: 24px;
          }
          .container {
            border: 1px solid #e0e0e0;
            background-color: #f7fee7;
            border-radius: 8px;
            padding: 30px;
            padding-bottom: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            margin: 0 auto;
            width: 100%;
            max-width: 600px;
          }
          .button {
            display: inline-block;
            background-color: #c6f648;
            color: #000 !important;
            padding: 12px 24px;
            text-decoration: none;
            border-radius: 5px;
            font-weight: 600;
            margin: 20px 0;
          }
          .footer {
            border-top: 1px solid #e0e0e0;
            padding-top: 10px;
            text-align: center;
            margin-top: 30px;
            color: #666666;
          }
          .unsubscribe-text {
            margin-top: 8px;
            color: #9ca3af;
            font-size: 11px;
            line-height: 1.4;
          }
          .unsubscribe-link {
            color: #1a73e8 !important;
            text-decoration: underline !important;
            text-underline-offset: 2px;
            font-weight: 400;
          }
          .font-16 { font-size: 16px; }
          .font-14 { font-size: 14px; }
          .font-12 { font-size: 12px; }
          .logo {
            width: 200px;
            height: auto;
            margin: 0 auto;
            display: block;
          }
          .link {
            text-decoration: underline;
            text-underline-offset: 3px;
            font-weight: 600;
          }
          p { margin: 0; }
          ul { margin: 0; padding-left: 20px; }
          li { margin: 0; margin-bottom: 8px; }
          .body-content { font-size: 16px; }
        </style>
      </head>
      <body>
        <div class="container font-16">
          ${props.content}
          <div class="footer font-12">
            <img src="https://assets.cobrief.app/LOGO-02.png" alt="Cobrief Logo" class="logo">
            <div class="unsubscribe-text">
              <p>
                You received this email because you signed up for Cobrief.
                <a href="${unsubscribeUrl}" target="_blank" class="unsubscribe-link" aria-label="Unsubscribe from Cobrief emails" title="Unsubscribe">
                  Unsubscribe
                </a>
              </p>
            </div>
          </div>
        </div>
      </body>
      </html>
    `
}
